export const WHITE = '#ffffff';
export const BLACK = '#000000';

export const PRIMARY = '#ffc514';
export const PRIMARY_LIGHT = '#ffdc72';
export const PRIMARY_DARK = '#4c3a05';

export const SECONDARY = '#a51a1c';
export const SECONDARY_LIGHT = '#eb393b';
export const SECONDARY_DARK = '#640a0b';

export const DARK = {
  100: '#e0e0e0',
  200: '#999999',
  500: '#545454',
  600: '#323232',
  700: '#232323',
  800: '#121212',
  900: '#000000'
};

export const COOL_GREY = {
  50: '#cbcdd2',
  100: '#b9bcc3',
  200: '#a2a6ae',
  300: '#838894',
  400: '#5e626c',
  500: '#2e3035',
  600: '#28292c',
  700: '#222326',
  800: '#1d1e20',
  900: '#19191b'
};

export const GREY = {
  50: '#eef5fa',
  100: '#e0e9ef',
  150: '#ced7de',
  200: '#c1c9cf',
  250: '#b6bcc0',
  300: '#a9aeb1',
  350: '#9ca1a5',
  400: '#93989c',
  450: '#848a8e',
  500: '#80868a',
  550: '#73787b',
  600: '#6b7175',
  650: '#606467',
  700: '#515557',
  750: '#424547',
  800: '#36383e',
  850: '#28292d',
  900: '#1b1c1e',
  950: '#121213'
};

export const BLUE_GREY = {
  50: '#caccd7',
  100: '#b9bac9',
  200: '#a1a4b8',
  300: '#8285a0',
  400: '#5d617b',
  500: '#333543',
  600: '#2d2e38',
  700: '#26272f',
  800: '#212227',
  900: '#1c1d21'
};

export const EXPRESSO = {
  50: '#f2d9bd',
  100: '#edcda7',
  200: '#e7bc8a',
  300: '#dfa563',
  400: '#d58830',
  500: '#935d1e',
  600: '#734e23',
  700: '#5e4222',
  800: '#4e381f',
  900: '#402f1c'
};

export const CASH_GAME = {
  50: '#c3ffad',
  100: '#afff92',
  200: '#94ff6d',
  300: '#70ff3c',
  400: '#43fb00',
  500: '#94ff6d',
  600: '#2c7e0e',
  700: '#276611',
  800: '#235312',
  900: '#1f4412'
};

export const SHORT_TRACK = {
  50: '#c4effb',
  100: '#b0eaf9',
  200: '#96e2f8',
  300: '#73d9f5',
  400: '#44ccf2',
  500: '#10b6e4',
  600: '#2090b0',
  700: '#21778f',
  800: '#216375',
  900: '#1f5260'
};

export const FLOOOP = {
  50: '#bcfff8',
  100: '#a6fff6',
  200: '#88fef3',
  300: '#61feef',
  400: '#2cfee9',
  500: '#01e2cd',
  600: '#14ad9e',
  700: '#178c81',
  800: '#197269',
  900: '#195d57'
};

export const MTT = {
  50: '#bcd5ff',
  100: '#a6c6ff',
  200: '#88b4fe',
  300: '#619afe',
  400: '#2c79fe',
  500: '#0153e2',
  600: '#144cad',
  700: '#17428c',
  800: '#193a72',
  900: '#19325d'
};

export const GOFAST_HOLDUP = {
  50: '#febfd6',
  100: '#feaac9',
  200: '#fe8eb7',
  300: '#fe689f',
  400: '#fd367f',
  500: '#ed0257',
  600: '#b61650',
  700: '#941946',
  800: '#781b3d',
  900: '#621b35'
};

export const SNG = {
  50: '#e6a3ff',
  100: '#de84ff',
  200: '#d35bff',
  300: '#c524ff',
  400: '#a000da',
  500: '#590079',
  600: '#470a5c',
  700: '#3a0c4b',
  800: '#300d3d',
  900: '#280d32'
};

export const YELLOW = {
  50: '#fff1c7',
  100: '#ffecb5',
  200: '#ffe69c',
  300: '#ffde7b',
  400: '#ffd34f',
  500: '#ffc514',
  600: '#d2a117',
  700: '#ab831d',
  800: '#8b6b1e',
  900: '#72581e'
};

export const RED = {
  50: '#ffd4d5',
  100: '#ffc5c6',
  200: '#ffb2b3',
  300: '#ff999a',
  400: '#ff7679',
  500: '#ff494c',
  600: '#e82f32',
  700: '#cc2124',
  800: '#a62326',
  900: '#882425'
};

export const getGameTypeColorBackground = (selectedChallengeId) => {
  if (selectedChallengeId === 'EXP') {
    return YELLOW[400];
  } else if (selectedChallengeId === 'CG') {
    return CASH_GAME[100];
  } else if (selectedChallengeId === 'SNG') {
    return SNG[100];
  } else if (selectedChallengeId === 'GP') {
    return '#3ed19c';
  } else if (selectedChallengeId === 'PM') {
    return '#9874ff';
  }

  return YELLOW[400];
};

export const getGameTypeColorFont = (selectedChallengeId) => {
  if (selectedChallengeId === 'EXP') {
    return PRIMARY;
  } else if (selectedChallengeId === 'CG') {
    return '#569a3e';
  } else if (selectedChallengeId === 'SNG') {
    return SNG[200];
  } else if (selectedChallengeId === 'GP') {
    return '#3ed19c';
  } else if (selectedChallengeId === 'PM') {
    return '#9874ff';
  }

  return PRIMARY;
};
